
import Vue, { defineComponent } from "vue";
export default defineComponent({
  name: "comedySvg",
  components: {},
  props: {
    color: {
      type: String,
      default: "red",
    },
  },
});
